import styled from 'styled-components';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';
import { COLOR_WHITE, COLOR_RED } from '../../../assets/styles/colors';
import { rgba } from 'polished';

export default styled.div`
  height: auto;
  background: grey;
  z-index: 99;
  width: 100%;
  position: absolute;
  top: 124px;
  display: none;
  justify-content: center;
  flex-direction: column;
  padding: 10px 16px 35px 16px;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.3);
  background-image: linear-gradient(to bottom, #3a3851, #2f2e41 84%, #1c1c2b);

  .mobile-menu-inner-wrap {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-end;

    .separator {
      width: 100%;
      margin: 30px 0 5px 0;
      height: 1px;
      background: ${rgba(COLOR_WHITE, 0.1)};
    }

    .user-btn {
      padding: 0px;
      margin: 24px 0 0 0;
      background: none;
      font-size: 18px;
      border: none;
      display: flex;
      align-items: center;
      .icon-wrap {
        margin-left: 10px;
        display: inline-block;
        width: 24px;
        text-align: center;
      }
      &.logout {
        color: ${COLOR_RED};
      }
      &.profile {
        .special-colored {
          background: -webkit-linear-gradient(180deg, #fab535, #f7931e);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }

    a {
      display: flex;
      align-items: center;
      margin: 25px 0px 0 0;
      color: ${COLOR_WHITE};
      opacity: 0.8;
      font-size: 18px;
      font-weight: normal;

      &:hover {
        text-decoration: none;
        color: ${COLOR_WHITE};
        opacity: 1;
      }
      &.active {
        color: ${COLOR_WHITE};
        opacity: 1;
        font-weight: 600;
      }
      .icon-wrap {
        margin-left: 29px;
        display: inline-block;
        min-width: 24px;
        text-align: center;
      }
    }
  }

  @media (max-width: ${BP_TABLET_MAX}px) {
    top: 80px;
    &.active {
      display: flex;
    }
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    top: 124px;
  }
`;
